var Panel			= require("../Panel");
var $               = require("jquery");
var template 		= require("./bar.ejs");
var search_item 	= require("./search_item.ejs");

var SearchBar = Panel.extend({

	initialize: function(options){
		var that = this;
		that.searchResults = [];

		if (!("layer" in options) && !("url" in options)) {
			throw new Error("Не переданы слой или url");
		} else if (!(options.layer instanceof omjs.ol.layer.Vector)) {
			throw new Error("Слой должен быть векторный");
		}

		SearchBar.__super__.initialize.call(that, options);

		that.selectedItem = -1;

		that.setOptions(options);
		that.layer = that.options.layer;
		that.map = that.options.map;

		that.layer.setStyle(new ol.style.Style({
			fill : new ol.style.Fill({
				color: 'rgba(255,0,0,0.4)'
			}),
			image: new ol.style.Circle({
				fill  : new ol.style.Fill({
					color: 'rgba(255,0,0,0.4)'
				}),
				stroke: new ol.style.Stroke({
					color: 'rgba(0,0,0,0.7)',
					width: 2
				}),
				radius: 10
			})
		}));

		that.container = that.getContainer();
		that.container.html( $(template({})) );
		that.container.attr("tabindex", "-1");

		if (that.options.url === null) {
			that.container.css("cursor", "not-allowed");
			that.container.find("*").prop("disabled", true).css("pointer-events", "none");
		}

		that._searchInputWrapper = that.container.find("._search-bar-input-wrapper");
		that._searchInput = that.container.find("input[name=search-bar]");
		that._searchButton = that.container.find("div[role=do_search]");
		that._searchResults = that.container.find("div[role=search_results]");
		that._searchResultsItems = that._searchResults.find("._search_result_item");

		that._initHandlers();

	},

	_initHandlers: function(){
		var that = this;
		var curElem, nextElem, prevElem;

		that._searchResults.on("click", "._search_result_item", function(){
			that._displayGeometry($(this).attr("data-id"));
			that.container.removeClass("active");
		});

		that._searchResults.on("mouseenter", "._search_result_item", function(){
			that._searchResultsItems.removeClass("active");
			$(this).addClass("active");
		});

		that._searchInput.on("keydown", function(event){
			if (event.keyCode == 13 && !that.nowLoading) {
				if (that._searchInput.val() != "" && (that.madeRequestWith == that._searchInput.val())) {
					if (that._searchResults.find(".active").length) {
						that._searchResults.find(".active").trigger("click");
						that._searchInput.blur();
					} else /* if (that.madeRequestWith != that._searchInput.val())*/ {
						that.makeSearchRequest();
					}
				} else {
					that.makeSearchRequest();
				}
				// Т.к. используется form для бага хрома версии 66.0.3359.139, необходимо вернуть false, чтобы страница не перезагрузилась 
				return false
			} else if (event.keyCode == 38) {
				// up
				event.preventDefault();
				curElem = that._searchResults.find(".active");

				if (!curElem.length) {
					curElem = that._searchResultsItems.first();
				}

				prevElem = curElem.prev();

				if (!prevElem.length) {
					prevElem = that._searchResultsItems.last();
				}

				curElem.removeClass("active");
				prevElem.addClass("active");

				//if (that.selectedItem === 0) {
				//	that.selectedItem = that._searchResultsItems.length-1;
				//} else {
                //
				//}
			} else if (event.keyCode == 40) {
				// down
				event.preventDefault();
				curElem = that._searchResults.find(".active");

				if (!curElem.length) {
					curElem = that._searchResultsItems.last();
				}

				nextElem = curElem.next();

				if (!nextElem.length) {
					nextElem = that._searchResultsItems.first();
				}

				curElem.removeClass("active");
				nextElem.addClass("active");


				//if (that.selectedItem == that._searchResultsItems.length-1) {
				//	that.selectedItem = 0;
				//}
			}
		});

		that._searchInput.on("keyup", function(){
			if ($(this).val().length == 0) {
				//очищаем маркеры и результаты поиска
				that.layer.setSource();
				that._searchResults.empty();
				that.container.removeClass("active");
			}
		});

		that._searchInput.focusin(function(){
			that._searchResultsItems.removeClass("active");
			that._searchInputWrapper.addClass("input-focused");
		});

		that._searchInput.blur(function(){
			that._searchInputWrapper.removeClass("input-focused");
		});

		that._searchButton.on("click", function(){
			if (that._searchInput.val() != "" && !that.nowLoading) {
				that.makeSearchRequest();
				that._searchInput.focus();
			}
		});

		that.container.on("click", function(e){
			if ($(e.target).hasClass("clearfix")) {
				that._searchInput.focus();
			}
		});

		that.container.focusin(function(){
			if (that._searchInput.val() != "" && !that._searchResults.is(":empty")) {
				that.container.addClass("active");
			}
		});

		that.container.focusout(function(){
			that._searchResultsItems.removeClass("active");
			that.container.removeClass("active");
		});

	},

	makeSearchRequest: function(){
		var that = this;

		$.ajax({
			url: that.options.url,
			method: "GET",
			data: {
				query: that._searchInput.val(),
				returnGeom: 1
			},
			beforeSend: function(){
				that.nowLoading = true;
				that._searchButton.addClass("loading");
				that.madeRequestWith = that._searchInput.val();
				that.searchResults.length = 0;
			}
		}).done(function(response){
			that.searchResults = response.results;
			that._renderResults(that.searchResults);
		}).fail(function(response){
			switch (response.status) {
				case 404:
					// сервер ничего не нашел
					that._handleEmptyAnswer();
					that.container.addClass("active");
					break;
				case 500:
					// сервер упал, всегда ваш кэп
					that._handleServerInternalError();
					that.container.addClass("active");
					break;
			}
			that.madeRequestWith = false;
		}).always(function(){
			that.nowLoading = false;
			that._searchButton.removeClass("loading");
		});
	},

	returnPathFromApiUrl: function(url){
		return url.replace(/(\/\/[a-zA-Z.]*)/, "");
	},

	_renderResults: function(response){
		var that = this;
		var $html;
		if (response.length) {
			$html = $("<ul role='results_container'></ul>");
			for (var i = 0; i < response.length; i++) {
				$html.append($(search_item({
					text: (response[i]["name"]||response[i]["address"]||response[i]["id"]),
					id: i,
					parents: response[i].parents
				})))
			}
			that._searchResults.html($html);
			that._searchResultsItems = $html.find("li[role='search_result_item']");
		} else {
			that._handleEmptyAnswer();
		}
		that.container.addClass("active");
		return $html;
	},

	_handleEmptyAnswer: function () {
		this._searchResults.html($("<div class='no-search-results'>По вашему запросу ничего не найдено</div>"));
	},

	_handleServerInternalError: function(){
		this._searchResults.html($("<div class='no-search-results'>Произошла ошибка на стороне сервера</div>"));
	},

	_displayGeometry: function(elemID){
		var that = this;
		var geom, geomType, geojson;

		if (!that.searchResults[elemID]) {
			return;
		} else {
			geomType = that.searchResults[elemID].bbox.type;

			geom = new ol.geom.Point(
				ol.proj.transform(that.searchResults[elemID].geom, "EPSG:4326", "EPSG:3857")
			);
		}

		that.map.getView().fit(geom, that.map.getSize(), {
			maxZoom: that.searchResults[elemID].zoom || 10
		});

		geojson = that._makeGeoJSONFromGeom({
			coordinates: that.searchResults[elemID].geom,
			type: "Point"
		});

		that.layer.setSource();
		that.layer.setSource( new ol.source.Vector({features: that._geojsonToFeature(geojson)}) )
	},

	_geojsonToFeature: function(geojson){
		var formatGeoJSON = new omjs.ol.format.GeoJSON();

		return  formatGeoJSON.readFeatures(geojson, {
			dataProjection: new omjs.ol.proj.Projection({code: "EPSG:3857"})
		});
	},

	_makeGeoJSONFromGeom: function(geom){
		var geoJSON = {};
		var geomCoordinates;
		var geomType = (geom.type.indexOf("Multi")!= -1)?
			geom.type.substring(5, geom.type.length):geom.type;

		geomCoordinates = omjs.ol.proj.transform(geom.coordinates, "EPSG:4326", "EPSG:3857");

		if (geomCoordinates.length > 1 && geom.type.indexOf("Multi")!= -1) {
			geoJSON =  {
				"type": "FeatureCollection",
				"features": []
			};

			for (var i = 0; i<geomCoordinates.length; i++) {
				geoJSON.features.push({
					"type": "Feature",
					"geometry": {
						"type": geomType,
						"coordinates": geomCoordinates[i]
					},
					"properties": null
				})
			}

		} else {
			geoJSON = {
				"type": "Feature",
				"geometry": {
					type: geom.type,
					coordinates: geomCoordinates
				},
				"properties": {}
			};
		}

		return geoJSON;
	}

});

module.exports = SearchBar;



//////////////////
// WEBPACK FOOTER
// ./src/View/Widget/SearchBar/SearchBar.js
// module id = 224
// module chunks = 0